import React, { useRef } from 'react';
import Hamburger from 'hamburger-react';
import './sidebar.scss';
import MENU_ITEMS from 'layout/Menu/constants/ConstMenuItems';
import { Link } from 'react-router-dom';
import useOutsideCloser from '_helpers/hooks/useOutsideCloser';
import determineAnimation from '_helpers/generic/Animations';
import useAnimation from '_helpers/hooks/useAnimation';
import ANIMATION_DURATION from 'constants/common/animation-duration';

export default function Sidebar() {
  const wrapperRef = useRef(null);
  const buttonRef = useRef(null);
  const { isOpen, setIsOpen } = useOutsideCloser(wrapperRef, buttonRef);
  const { setAnimation, currentPageIndex, setCurrentPageIndex } = useAnimation();

  return (
    <>
      <div
        ref={buttonRef}
        className={`hamburger ${isOpen ? 'hamburger-open' : ''}`}
        style={{ transitionDuration: `${ANIMATION_DURATION}s` }}>
        <Hamburger distance="md" rounded size={20} toggled={isOpen} toggle={setIsOpen} />
      </div>
      <div
        ref={wrapperRef}
        className={`pt-6 sidebar  ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}
        style={{ transitionDuration: `${ANIMATION_DURATION}s` }}>
        {MENU_ITEMS.map((e, i) => (
          <Link
            key={e.link}
            className={`${isOpen ? 'block' : 'hidden'} flex items-center gap-3 text-lg font-light mx-4 my-6 ${
              i === currentPageIndex ? 'opacity-100' : 'opacity-30'
            }`}
            to={e.link}
            onClick={() => {
              setAnimation(determineAnimation(e?.link));
              setCurrentPageIndex(i);
              setIsOpen(false);
            }}>
            <img src={e?.icon} className="h-5 w-5" alt="Menu item icon" />
            <div className="whitespace-nowrap text-md">{e.title}</div>
          </Link>
        ))}
      </div>
    </>
  );
}
